module.exports = __webpack_public_path__ + "static/media/address.35cce85d.svg";